import type { GetSanAdAccountZeitStatusAction } from '../../actions/getSANAdPartnerZeitStatus';
import type { GetCriteoAuthenticationUrlAction } from './getAuthenticationUrl.action';

export * from './getAuthenticationUrl.action';

export type CriteoAction = GetCriteoAuthenticationUrlAction | GetSanAdAccountZeitStatusAction;
